import client from './client';

export const historyOfCustomer = (custId) => client.get(`/history/customer/${custId}`).then((r) => r.data);
export const addCustomerNote = (custId, note) =>
  client.post(`/history/customer/${custId}/note`, { note }).then((r) => r.data);
export const listExchangeLog = (params) => client.get('/history', { params }).then((r) => r.data);
export const pushHistoryToSocson = (id) => client.post(`/history/${id}/push-socson`).then((r) => r.data);
